import React from 'react';

function Header() {
    return (
        <div id="global-header"></div>
    )
}

export default Header;